import React from 'react';
import MyInvoisStatusLayout from './components/status_layout';
import { useParams } from 'react-router-dom';

const MyInvoisStatus = () => {
    const { document_id } = useParams();

    return (
        <>
            <MyInvoisStatusLayout document_id={document_id} />
        </>
    );
}

export default MyInvoisStatus;